import { ParamIds, Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class UserProfileKeys extends MainKeys {
    get place() {
        return Places.profile
    }

    get startMonthFilter() {
        return this._intent.getParameterAsString(ParamIds.profileStMoFilter)
    }

    set startMonthFilter(value: string | undefined) {
        this._intent.setParameter(ParamIds.profileStMoFilter, value)
    }

    get endMonthFilter() {
        return this._intent.getParameterAsString(ParamIds.profileEnMoFilter)
    }

    set endMonthFilter(value: string | undefined) {
        this._intent.setParameter(ParamIds.profileEnMoFilter, value)
    }

    get pageFilter() {
        return this._intent.getParameterAsNumber(ParamIds.profilePageFilter)
    }

    set pageFilter(value: number | undefined) {
        this._intent.setParameter(ParamIds.profilePageFilter, value)
    }

    get limitFilter() {
        return this._intent.getParameterAsNumber(ParamIds.profileLimitFilter)
    }

    set limitFilter(value: number | undefined) {
        this._intent.setParameter(ParamIds.profileLimitFilter, value)
    }
}

export default UserProfileKeys
